import { render, staticRenderFns } from "./ups-downs-spot.vue?vue&type=template&id=18391c93&scoped=true"
import script from "./ups-downs-spot.vue?vue&type=script&lang=js"
export * from "./ups-downs-spot.vue?vue&type=script&lang=js"
import style0 from "./ups-downs-spot.vue?vue&type=style&index=0&id=18391c93&prod&lang=css"
import style1 from "./ups-downs-spot.vue?vue&type=style&index=1&id=18391c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18391c93",
  null
  
)

export default component.exports